import React, { useEffect, useState } from "react";
import BlogCard from "./Cards/BlogCard";
import AdminPostTabs from "./AdminPostTabs";
import Loader from "../utils/loader";
import { withRouter } from "react-router-dom";
import HeadingB from "./Cards/HeadingB";
import BreadCrumb from "./Cards/BreadCrumbs";
import {
  getPendingBlogs,
  acceptPendingBlog,
  rejectPendingBlog,
  getAdminBlogs,
  publishMyBlogs,
  unpublishMyBlogs,
  getBlogById,
  searchPendingBlogs,
  searchAdminblog,
  deletePermanentlyBlog
} from "../services/adminServices";
import { getCurrentUser } from "../services/authService";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
  Container,
  Paper,
  Typography,
  Box,
  Chip,
  Stack,
  IconButton,
  Card,
  CardContent,
  CardActions,
  Tooltip,
  InputAdornment,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
  Avatar,
} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import Pagination from '@mui/material/Pagination';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import RefreshIcon from '@mui/icons-material/Refresh';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import PublishIcon from '@mui/icons-material/Publish';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import {Delete} from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import ArticleIcon from '@mui/icons-material/Article';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import swal from "sweetalert";
import { toast } from "react-toastify";
import seoServices from "../services/seoServices";
import SEOBlogCard from "./Cards/SEOBlogCard";
import { addUserLogs } from "../services/userLogServices";

function AdminBlogs({ history }) {
  const [loading, setLoading] = useState(false);
  const [tabValue, setSwitchTabValue] = useState(0);
  const [pendingBlogs, setPendingBlogs] = useState([]);
  const [filterPending, setFilterPending] = useState([]);
  const [isAdmin, setIsAdmin] = useState(false);
  const [open, setOpen] = useState(false);
  const [myblog, setMyBlog] = useState(false);
  const [rejectedblog, setRejectedblog] = useState({});
  const [reason, setReason] = useState("");
  const [blogValue, setBlogValue] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [pageItems] = useState(10);
  const [search, setSearch] = useState("");
  const [hidePagination, setHidePagination] = useState(false);
  const [statusFilter, setStatusFilter] = useState("all");

  useEffect(() => {
    setLoading(true);
    initialCall();
    if (tabValue === 0) {
      setMyBlog(false);
      setBlogValue("all");
      fetchPendingBlogs();
    } else {
      setMyBlog(true);
      setBlogValue("my");
      myBlogs();
    }
  }, [tabValue, currentPage]);

  const initialCall = async () => {
    const user = await getCurrentUser();
    if (user.isAdmin) {
      setIsAdmin(true);
    }
  };

  const fetchPendingBlogs = async () => {
    let data = await getPendingBlogs(pageItems, currentPage);
    setPendingBlogs(data.data);
    setFilterPending(data.data);
    setTotalItems(data.total);
    setLoading(false);
  };

  const myBlogs = async () => {
    let data = await seoServices.getAllSEOBlogs(pageItems, currentPage);
    setPendingBlogs(data.data);
    setFilterPending(data.data);
    setTotalItems(data.total);
    setLoading(false);
  };

  const viewBlog = (blog) => {
    history.push({
      pathname: `/blogpreview/${blog._id}`,
      state: { detail: blog, blogType: blogValue },
      data: { documentType: "blog" },
    });
  };

  const openTextEditor = () => {
    history.push({
      pathname: `/blogeditor`,
    });
  };

  const approveBlog = async (data) => {
    swal({
      title: "Approve Blog",
      text: "Are you sure you want to approve this blog?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willApprove) => {
      if (willApprove) {
        setLoading(true);
        let blog = {
          BlogID: data._id,
          BlogName: data.documentName,
          userID: data.editor._id,
        };
        let response = await acceptPendingBlog(blog);
        if (response.status === 200) {
          fetchPendingBlogs();
          toast.success("Blog approved successfully.");
        } else {
          toast.error(response.message);
        }
        setLoading(false);
      }
    });
  };

  const rejectBlog = async () => {
    if (!reason) {
      toast.warn("Please enter a valid reason");
    } else {
      setLoading(true);
      let blog = {
        BlogID: rejectedblog._id,
        BlogName: rejectedblog.documentName,
        userID: rejectedblog.editor._id,
        userEmail: rejectedblog.editor.email,
        Message: reason,
      };
      let response = await rejectPendingBlog(blog);
      if (response.status === 200) {
        fetchPendingBlogs();
        toast.success("Blog rejected successfully.");
      } else {
        toast.error(response.message);
      }
      setLoading(false);
    }
    setOpen(false);
    setReason("");
  };

  const handlePublish = async (data) => {
    swal({
      title: "Publish Blog",
      text: "Are you sure you want to publish this blog?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willPublish) => {
      if (willPublish) {
        let blog = await getBlogById(data._id);
        if (blog.status === 200) {
          if (blog.data.activeDoc === true) {
            let responseBlog = await publishMyBlogs(data._id);
            toast.success("Blog published!");
          }
          myBlogs();
        }
      }
    });
  };

  const handleUnpublish = async (data) => {
    swal({
      title: "Unpublish Blog",
      text: "Are you sure you want to unpublish this blog?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willunPublish) => {
      if (willunPublish) {
        let blog = await getBlogById(data._id);
        if (blog.status === 200) {
          if (blog.data.activeDoc === true) {
            let unpublishBlog = await unpublishMyBlogs(data._id);
            toast.success("Blog unpublished!");
          }
          myBlogs();
        } else {
          toast.error("Something went wrong");
        }
      }
    });
  };

  const switchTab = (value) => {
    setSwitchTabValue(value);
    setCurrentPage(1);
  };

  const switchDialog = (value, data) => {
    setOpen(value);
    setRejectedblog(data);
  };

  const onChangeSearch = async (e) => {
    setSearch(e.target.value);
    if (e.target.value === "") {
      setFilterPending(pendingBlogs);
      setHidePagination(false);
    }
  };

  const searchBlog = async () => {
    let word = search.trim();
    setSearch(word);
    if (word === "") {
      return;
    } else {
      setHidePagination(true);
      if (tabValue === 0) {
        let data = await searchPendingBlogs(word);
        setFilterPending(data.data);
      } else {
        let data = await searchAdminblog(word);
        setFilterPending(data.data);
      }
    }
  };

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      searchBlog();
    }
  };

  const permanentDeleteBlog = async (blog) => {
    swal({
      title: "Permanent Deletion",
      text: "Do you want to permanently delete this blog?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (permanentDelete) => {
      if (permanentDelete) {
        setLoading(true);
        let data = { _id: blog._id };
        let res = await deletePermanentlyBlog(data);
        if (res.status !== 200) {
          setLoading(false);
          toast.error("Blog deletion failed!");
        } else {
          toast.success("Blog deleted permanently!");
          const logData = {
            userId: sessionStorage.getItem("userId"),
            organizationId: sessionStorage.getItem("organizationId"),
            actionType: "deleteBlog",
          };
          await addUserLogs(logData);
          setLoading(false);
          if (tabValue === 0) {
            fetchPendingBlogs();
          } else {
            myBlogs();
          }
        }
      } else {
        swal("Your blog is safe!");
      }
    });
  };

  const viewSEOBlog = (blog) => {
    history.push({
      pathname: `/blogeditor`,
      seo: { detail: blog },
    });
  };

  const refreshContent = () => {
    if (tabValue === 0) {
      fetchPendingBlogs();
    } else {
      myBlogs();
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'published':
        return 'success';
      case 'pending':
        return 'warning';
      case 'draft':
        return 'default';
      default:
        return 'default';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Invalid Date';
    try {
      const date = new Date(dateString);
      return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleDateString();
    } catch (error) {
      return 'Invalid Date';
    }
  };

  const getInitials = (name) => {
    if (!name) return '?';
    return name.charAt(0).toUpperCase();
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4, backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
      <Loader loading={loading} />
      
      {/* Header Section */}
      <Paper 
        elevation={0} 
        sx={{ 
          p: 2, 
          mb: 2, 
          borderRadius: 3,
          backgroundColor: 'white',
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
        }}
      >
        <Grid container spacing={3} alignItems="center" justifyContent="space-between">
          <Grid xs={12} md={6}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: '#1a237e'}}>
              Here's a Blogs
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" sx={{ display: 'flex', alignItems: 'center' }}>
              <Box component="span" sx={{ color: '#1976d2', fontWeight: 600, mr: 1 }}>
                {filterPending.length}
              </Box>
              {filterPending.length === 1 ? 'blog' : 'blogs'} found
            </Typography>
          </Grid>
          
          <Grid xs={12} md={6}>
            <Grid container spacing={2} alignItems="center" justifyContent="flex-end">
              <Grid xs={12} sm={8} md={7}>
                <TextField
                  fullWidth
                  // placeholder="Search blogs by title or author..."
                  placeholder="Search by title or author..."
                  value={search}
                  onChange={onChangeSearch}
                  onKeyPress={handleSearchKeyPress}
                  size="medium"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ color: '#1976d2' }} />
                      </InputAdornment>
                    ),
                    sx: {
                      borderRadius: 2,
                      backgroundColor: '#f8f9fa',
                      '&:hover': {
                        backgroundColor: '#f1f3f4',
                      },
                      '&.Mui-focused': {
                        backgroundColor: 'white',
                        boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)'
                      }
                    }
                  }}
                />
              </Grid>
              
              <Grid xs={12} sm={4} md={3}>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={openTextEditor}
                  fullWidth
                  sx={{ 
                    borderRadius: 2, 
                    height: '48px',
                    fontWeight: 600,
                    textTransform: 'none',
                    fontSize: '0.95rem'
                  }}
                >
                  New Blog
                </Button>
              </Grid>
              
              <Grid xs={12} sm={4} md={2}>
                <Tooltip title="Refresh list">
                  <IconButton
                    onClick={refreshContent}
                    sx={{
                      backgroundColor: '#1976d2',
                      color: 'white',
                      '&:hover': { 
                        backgroundColor: '#1565c0',
                        transform: 'rotate(90deg)',
                        transition: 'transform 0.3s ease'
                      },
                      borderRadius: 2,
                      height: '48px',
                      width: '48px',
                      boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)'
                    }}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {/* Tabs Section */}
      <Paper 
        elevation={0} 
        sx={{ 
          p: 2, 
          mb: 2, 
          borderRadius: 3,
          backgroundColor: 'white',
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: '#333' }}>
          Blog Categories
        </Typography>
        <Stack direction="row" spacing={2}>
          <Chip
            label="Pending Blogs"
            onClick={() => switchTab(0)}
            color={tabValue === 0 ? "primary" : "default"}
            variant={tabValue === 0 ? "filled" : "outlined"}
            sx={{ 
              px: 4, 
              py: 2, 
              fontWeight: 600,
              fontSize: '0.95rem',
              borderRadius: 2,
              '&:hover': {
                backgroundColor: tabValue === 0 ? '#1976d2' : 'rgba(0, 0, 0, 0.04)'
              }
            }}
          />
          <Chip
            label="My Blogs"
            onClick={() => switchTab(1)}
            color={tabValue === 1 ? "primary" : "default"}
            variant={tabValue === 1 ? "filled" : "outlined"}
            sx={{ 
              px: 4, 
              py: 2, 
              fontWeight: 600,
              fontSize: '0.95rem',
              borderRadius: 2,
              '&:hover': {
                backgroundColor: tabValue === 1 ? '#1976d2' : 'rgba(0, 0, 0, 0.04)'
              }
            }}
          />
        </Stack>
      </Paper>

      {/* Blogs List */}
      <Paper 
        elevation={0} 
        sx={{ 
          p: 2, 
          borderRadius: 3,
          backgroundColor: 'white',
          boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
          minHeight: '300px'
        }}
      >
        {filterPending.length > 0 ? (
          <>
            <Grid container spacing={2}>
              {filterPending.map((blog, index) => (
                <Grid xs={12} key={blog._id} sx={{ mb: 1 }}>
                  <Card 
                    sx={{ 
                      borderRadius: 3,
                      border: '1px solid #e0e0e0',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
                        transform: 'translateY(-2px)',
                        borderColor: '#1976d2'
                      }
                    }}
                  >
                    <CardContent sx={{ p: 3 }}>
                      <Grid container spacing={2} alignItems="center">
                        {/* Left Content */}
                        <Grid xs={12} md={8}>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Avatar 
                              sx={{ 
                                mr: 2, 
                                bgcolor: '#1976d2',
                                width: 40,
                                height: 40,
                                fontWeight: 600
                              }}
                            >
                              {getInitials(blog.documentName || blog.title)}
                            </Avatar>
                            <Box>
                              <Typography 
                                variant="h6" 
                                sx={{ 
                                  fontWeight: 700,
                                  color: '#1a237e',
                                  lineHeight: 1.2
                                }}
                              >
                                {blog.documentName || blog.title || 'Untitled Blog'}
                              </Typography>
                              <Typography 
                                variant="body2" 
                                color="text.secondary"
                                sx={{ 
                                  mt: 0.5,
                                  display: '-webkit-box',
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: 'vertical',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                {blog.description || 'No description available'}
                              </Typography>
                            </Box>
                          </Box>
                          
                          {/* Metadata */}
                          <Stack direction="row" spacing={3} alignItems="center" sx={{ mt: 3 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <PersonIcon sx={{ mr: 1, color: '#666', fontSize: 18 }} />
                              <Typography variant="body2" color="text.secondary">
                                {blog.editor?.username || 'Unknown Author'}
                              </Typography>
                            </Box>
                            
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                              <AccessTimeIcon sx={{ mr: 1, color: '#666', fontSize: 18 }} />
                              <Typography variant="body2" color="text.secondary">
                                {formatDate(blog.createdAt)}
                              </Typography>
                            </Box>
                            
                            <Chip
                              label={blog.status?.toUpperCase() || 'PENDING'}
                              size="small"
                              color={getStatusColor(blog.status)}
                              sx={{ 
                                fontWeight: 600,
                                borderRadius: 1
                              }}
                            />
                          </Stack>
                        </Grid>
                        
                        {/* Right Actions */}
                        <Grid xs={12} md={4}>
                          <CardActions sx={{ 
                            justifyContent: 'flex-end', 
                            flexWrap: 'wrap',
                            gap: 1.5,
                            '& .MuiIconButton-root': {
                              transition: 'all 0.2s ease'
                            }
                          }}>
                            {tabValue === 0 ? (
                              <>
                                <Tooltip title="Preview Blog">
                                  <IconButton
                                    size="medium"
                                    onClick={() => viewBlog(blog)}
                                    sx={{ 
                                      backgroundColor: '#e3f2fd',
                                      color: '#1976d2',
                                      '&:hover': {
                                        backgroundColor: '#bbdefb',
                                        transform: 'scale(1.1)'
                                      }
                                    }}
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                </Tooltip>
                                
                                <Tooltip title="Approve Blog">
                                  <IconButton
                                    size="medium"
                                    onClick={() => approveBlog(blog)}
                                    sx={{ 
                                      backgroundColor: '#e8f5e9',
                                      color: '#2e7d32',
                                      '&:hover': {
                                        backgroundColor: '#c8e6c9',
                                        transform: 'scale(1.1)'
                                      }
                                    }}
                                  >
                                    <CheckCircleIcon />
                                  </IconButton>
                                </Tooltip>
                                
                                <Tooltip title="Reject Blog">
                                  <IconButton
                                    size="medium"
                                    onClick={() => switchDialog(true, blog)}
                                    sx={{ 
                                      backgroundColor: '#ffebee',
                                      color: '#d32f2f',
                                      '&:hover': {
                                        backgroundColor: '#ffcdd2',
                                        transform: 'scale(1.1)'
                                      }
                                    }}
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </Tooltip>
                                
                                <Tooltip title="Delete Permanently">
                                  <IconButton
                                    size="medium"
                                    onClick={() => permanentDeleteBlog(blog)}
                                    sx={{ 
                                      backgroundColor: '#fce4ec',
                                      color: '#c2185b',
                                      '&:hover': {
                                        backgroundColor: '#f8bbd9',
                                        transform: 'scale(1.1)'
                                      }
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                </Tooltip>
                              </>
                            ) : (
                              <>
                                <Tooltip title="Edit Blog">
                                  <IconButton
                                    size="medium"
                                    onClick={() => viewSEOBlog(blog)}
                                    sx={{ 
                                      backgroundColor: '#e3f2fd',
                                      color: '#1976d2',
                                      '&:hover': {
                                        backgroundColor: '#bbdefb',
                                        transform: 'scale(1.1)'
                                      }
                                    }}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                </Tooltip>
                                
                                <Tooltip title={blog.activeDoc ? "Unpublish" : "Publish"}>
                                  <IconButton
                                    size="medium"
                                    onClick={() => blog.activeDoc ? handleUnpublish(blog) : handlePublish(blog)}
                                    sx={{ 
                                      backgroundColor: blog.activeDoc ? '#fff3e0' : '#e8f5e9',
                                      color: blog.activeDoc ? '#ef6c00' : '#2e7d32',
                                      '&:hover': {
                                        backgroundColor: blog.activeDoc ? '#ffe0b2' : '#c8e6c9',
                                        transform: 'scale(1.1)'
                                      }
                                    }}
                                  >
                                    {blog.activeDoc ? <UnpublishedIcon /> : <PublishIcon />}
                                  </IconButton>
                                </Tooltip>
                                
                                <Tooltip title="Preview Blog">
                                  <IconButton
                                    size="medium"
                                    onClick={() => viewBlog(blog)}
                                    sx={{ 
                                      backgroundColor: '#f3e5f5',
                                      color: '#7b1fa2',
                                      '&:hover': {
                                        backgroundColor: '#e1bee7',
                                        transform: 'scale(1.1)'
                                      }
                                    }}
                                  >
                                    <VisibilityIcon />
                                  </IconButton>
                                </Tooltip>
                                
                                <Tooltip title="Delete Permanently">
                                  <IconButton
                                    size="medium"
                                    onClick={() => permanentDeleteBlog(blog)}
                                    sx={{ 
                                      backgroundColor: '#ffebee',
                                      color: '#d32f2f',
                                      '&:hover': {
                                        backgroundColor: '#ffcdd2',
                                        transform: 'scale(1.1)'
                                      }
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}
                          </CardActions>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
            
            {/* Pagination */}
            {totalItems > pageItems && !hidePagination && (
              <Box sx={{ mt: 6, display: 'flex', justifyContent: 'center' }}>
                <Pagination
                  count={Math.ceil(totalItems / pageItems)}
                  page={currentPage}
                  onChange={(event, page) => setCurrentPage(page)}
                  color="primary"
                  size="large"
                  showFirstButton
                  showLastButton
                  sx={{
                    '& .MuiPaginationItem-root': {
                      borderRadius: 2,
                      mx: 0.5,
                      '&.Mui-selected': {
                        boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)'
                      }
                    }
                  }}
                />
              </Box>
            )}
          </>
        ) : (
          <Box sx={{ 
            textAlign: 'center', 
            py: 8,
            backgroundColor: '#fafafa',
            borderRadius: 3
          }}>
            <Avatar
              sx={{ 
                width: 80, 
                height: 80, 
                mx: 'auto', 
                mb: 3,
                backgroundColor: '#e3f2fd',
                color: '#1976d2'
              }}
            >
              <ArticleIcon sx={{ fontSize: 40 }} />
            </Avatar>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, color: '#555' }}>
              No Blogs Found
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: '400px', mx: 'auto' }}>
              {search ? `No blogs match "${search}". Try a different search term.` : 'Start creating your first blog post!'}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={openTextEditor}
              sx={{ 
                borderRadius: 2,
                px: 4,
                py: 1.5,
                fontWeight: 600,
                textTransform: 'none',
                fontSize: '1rem'
              }}
            >
              Create New Blog
            </Button>
          </Box>
        )}
      </Paper>

      {/* Rejection Dialog */}
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
          setReason("");
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: { borderRadius: 3 }
        }}
      >
        <DialogTitle sx={{ pb: 2, borderBottom: '1px solid #e0e0e0' }}>
          <Typography variant="h5" fontWeight={700} color="#d32f2f">
            Reject Blog
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ py: 3 }}>
          <DialogContentText sx={{ mb: 3, color: '#555' }}>
            Please provide a reason for rejecting the blog:
            <Typography variant="subtitle1" sx={{ mt: 1, fontWeight: 600, color: '#333' }}>
              "{rejectedblog.documentName || rejectedblog.title}"
            </Typography>
          </DialogContentText>
          <TextField
            autoFocus
            multiline
            rows={5}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            label="Reason for rejection"
            fullWidth
            variant="outlined"
            sx={{ mb: 2 }}
            InputProps={{
              sx: { borderRadius: 2 }
            }}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 2, borderTop: '1px solid #e0e0e0' }}>
          <Button
            onClick={() => {
              setOpen(false);
              setReason("");
            }}
            sx={{ 
              borderRadius: 2,
              px: 4,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={rejectBlog}
            variant="contained"
            color="error"
            disabled={!reason.trim()}
            sx={{ 
              borderRadius: 2,
              px: 4,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Reject Blog
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default withRouter(AdminBlogs);
